import { render, staticRenderFns } from "./userworks.vue?vue&type=template&id=d2605bf8&scoped=true&"
import script from "./userworks.vue?vue&type=script&lang=js&"
export * from "./userworks.vue?vue&type=script&lang=js&"
import style0 from "./userworks.vue?vue&type=style&index=0&id=d2605bf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2605bf8",
  null
  
)

export default component.exports